module.exports = __webpack_public_path__ + "static/media/frc-easter-image-1.9746ca57.jpg";